import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { MaybeExternalLinkDirective } from '@woolworthsnz/styleguide';

export enum LoadingStrategy {
	Eager = 'eager',
	Lazy = 'lazy',
}

@Component({
	selector: 'wnz-hero-item-main-image',
	standalone: true,
	imports: [NgIf, NgClass, MaybeExternalLinkDirective],
	templateUrl: './hero-item-main-image.component.html',
	styleUrls: ['./hero-item-main-image.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroItemMainImageComponent {
	@Input() imageUrl: string;
	@Input() imageAltText: string;
	@Input() link = '';
	@Input() loadingStrategy?: LoadingStrategy = LoadingStrategy.Eager;

	@HostBinding('attr.image-error')
	showImageError = false;

	@Output() imageClicked = new EventEmitter<void>();

	onClickMainImage(): void {
		this.imageClicked.emit();
	}

	handleImageError(): void {
		this.showImageError = true;
	}
}
